import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { SimpleFinn } from 'src/app/utilities/simpleFinn';

export interface InternalTourData {
  dispatchCompanyCount: number;
  dispatchCompanyWithDriversCount: number;
  dispatchCompanyWithTourDriversCount: number;
  dispatcherUserCount: number;
  carrierCompanyCount: number;
  driversWhoCouldDoTourCount: number;
  driversWhoCouldDoTourHaveLoggedInCount: number;
  inProgressTourCount: number;
  totalCreatedTourCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class FiveFTourInternalDashboardService {
  private internalTourData: SimpleFinn<InternalTourData>;

  public get internalTourData$(): Observable<InternalTourData> {
    return this.internalTourData.get$();
  }

  constructor(
    private httpClient: HttpClient,
  ) {
    this.internalTourData = new SimpleFinn<InternalTourData>(null, this.loadInternalTourData.bind(this));
  }

  private async loadInternalTourData() {
    return this.httpClient
      .get<{ internalTourStats: InternalTourData }>(`${environment.api}/v2/internal/tours/tour_stats`)
      .pipe(pluck('internalTourStats'))
      .toPromise();
  }
}
